import { EditIcon } from 'assets/images/svg';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import ManageAssociatedPeopleModal from 'zComponents/molecules/ManageAssociatedPeopleModal';

import { Button, Col, Row, Tooltip } from 'zui/Antd';

const DependantPanelExtra = ({ personID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const canManageAssociatedPeople = useManagePermittedRoles('manageAssociatedPeople');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	const [openModal, setOpenModal] = useState(false);

	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canManageAssociatedPeople) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('associatedPeople')) {
			setActiveKeys([...activeKeys, 'associatedPeople']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('associatedPeople')) {
					return [...prev, 'associatedPeople'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canManageAssociatedPeople ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canManageAssociatedPeople}
						/>
					</span>
				</Tooltip>
			</Col>
			<ManageAssociatedPeopleModal visible={openModal} setVisible={handleCloseModal} personID={personID}>
				<div />
			</ManageAssociatedPeopleModal>
		</Row>
	);
};

export default DependantPanelExtra;
